import Icon from '@material-ui/icons/Speaker';
import React from 'react';
import { CreateButton } from '../../../../../buttons';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../../../controllers';
import { TextField } from '../../../../../fields';
import { BooleanInput, NumberInput, ReferenceInput, SearchInput, TextInput } from '../../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="id"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ product_sku_trait_value_id: props.parentResource.id }}
        {...props}
      >
        <ReferenceInput
          source="location_id"
          required
        />
        <NumberInput
          source="quantity"
          required
        />
        <TextInput
          source="details"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="name"
        />
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
